"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _promise2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("react-app-polyfill/ie11");

require("react-app-polyfill/stable");

var _Utils = require("./Utils");

/**
 * Javascript Wrapper for Optimizely APIs
 */

/* eslint-disable no-console */

/* eslint object-shorthand: [2, "never"] */

/**
 * Loads the library. Clients can call this directly if they want to by pass the A/B split
 */
var $sflyOptimizely = {};
exports.default = $sflyOptimizely;
var headers = {
  'Content-Type': 'text/plain',
  'SFLY-ApiKey': (0, _Utils.getAPIKey)()
}; // TRNT-1386 Mobile Safari CACHES POST CALLS by default!

var postHeaders = {
  'Content-Type': 'text/plain',
  'SFLY-ApiKey': (0, _Utils.getAPIKey)(),
  'cache-control': 'no-cache'
}; // Add $sflyOptimizely as a global object.

window.$sflyOptimizely = $sflyOptimizely; // Main functions
// --------------

/**
 * Handle fetch JSON response
 */

var handleJSONResponse = function handleJSONResponse(response) {
  return response.json().then(function (json) {
    if (response.ok) {
      return json;
    } else {
      return _promise2.default.reject((0, _assign.default)({}, json, {
        status: response.status,
        statusText: response.statusText
      }));
    }
  });
};
/**
 * Handle fetch text response
 */


var handleTextResponse = function handleTextResponse(response) {
  var promise = response.text().then(function (text) {
    if (response.ok) {
      return text;
    } else {
      return _promise2.default.reject({
        status: response.status,
        statusText: response.statusText,
        err: text
      });
    }
  });
  return promise;
};
/**
 * Handle fetch response and error handling
 */


var handleResponse = function handleResponse(response) {
  var contentType = response.headers.get('content-type');

  if (contentType.includes('application/json')) {
    return handleJSONResponse(response);
  } else if (contentType.includes('text/plain')) {
    return handleTextResponse(response);
  } else {
    return _promise2.default.reject({
      status: response.status,
      statusText: response.statusText,
      err: "Sorry, content-type ".concat(contentType, " not supported")
    });
  }
}; // report dtl


$sflyOptimizely.reportDTL = function (omnitureData) {
  if (window.$omnitureDTL) {
    window.$omnitureDTL.putOmnitureJSPData(window.location.origin, omnitureData);
  } else if (typeof window.putOmnitureJSPData !== 'undefined') {
    window.putOmnitureJSPData(omnitureData);
  }
}; // window.$sflyOptimizely.datafile must be defined.


$sflyOptimizely.lookupExperimentAndVariation = function (experimentKey, variationKey) {
  if (typeof window.$sflyOptimizely.datafile !== 'undefined') {
    var foundExp = window.$sflyOptimizely.datafile.experiments.find(function (experiment) {
      return experiment.key === experimentKey;
    });

    if (typeof foundExp !== 'undefined') {
      var foundVariation = foundExp.variations.find(function (variation) {
        return variation.key === variationKey;
      });

      if (typeof foundVariation !== 'undefined') {
        return [foundExp.id, foundVariation.id];
      }
    }
  }

  return null;
};
/**
 *  Log experiment activation to adobe.
 */


$sflyOptimizely.logActivateToAdobe = function (experimentKey, uid, data, variationKey) {
  if (typeof window.$sflyOptimizely.datafile === 'undefined') {
    $sflyOptimizely.getDatafile().then(function (s) {
      window.$sflyOptimizely.datafile = JSON.parse(s);

      if (window.$sflyOptimizely.datafile == null) {
        return; // avoid infinite loop
      } // call self recursively now that datafile is ok


      $sflyOptimizely.logActivateToAdobe(experimentKey, uid, data, variationKey);
    });
    return;
  } // We know that datafile is not null.


  var experimentAndVariationNumbers = $sflyOptimizely.lookupExperimentAndVariation(experimentKey, variationKey);

  if (experimentAndVariationNumbers != null && experimentAndVariationNumbers.length === 2) {
    var DTLToReport = {
      optimizely: {
        activate: {
          experiment: "".concat(experimentKey, "(").concat(experimentAndVariationNumbers[0], ")"),
          variation: "".concat(variationKey, "(").concat(experimentAndVariationNumbers[1], ")")
        }
      }
    };
    $sflyOptimizely.reportDTL(DTLToReport);
  }
}; // window.$sflyOptimizely.datafile must be defined.


$sflyOptimizely.lookupFeatureByName = function (featureName) {
  if (typeof window.$sflyOptimizely.datafile !== 'undefined') {
    var foundFeature = window.$sflyOptimizely.datafile.featureFlags.find(function (feature) {
      return feature.key === featureName;
    });

    if (typeof foundFeature !== 'undefined') {
      return foundFeature.id;
    }
  }

  return null;
};
/**
 *  Log isFeatureEnabled to Adobe.  isFeatureEnabled also records an impression.
 *  Activate and isFeatureEnabled are the only two calls that record impressions.
 */


$sflyOptimizely.logIsFeatureEnabledToAdobe = function (featureName, uid, data, isItEnabled) {
  if (typeof window.$sflyOptimizely.datafile === 'undefined') {
    $sflyOptimizely.getDatafile().then(function (s) {
      window.$sflyOptimizely.datafile = JSON.parse(s);

      if (typeof window.$sflyOptimizely.datafile === 'undefined') {
        return; // avoid infinite loop
      } // call self recursively now that datafile is ok


      $sflyOptimizely.logIsFeatureEnabledToAdobe(featureName, uid, data, isItEnabled);
    });
    return;
  } // We know that datafile is not null.


  var featureNumber = $sflyOptimizely.lookupFeatureByName(featureName);

  if (featureNumber != null) {
    var DTLToReport = {
      optimizely: {
        isFeatureEnabled: {
          feature: "".concat(featureName, "(").concat(featureNumber, ")"),
          enabled: isItEnabled
        }
      }
    };
    $sflyOptimizely.reportDTL(DTLToReport);
  }
};

$sflyOptimizely.optimizelyLoggingEnabled = function () {
  return window.localStorage.getItem('enable_optimizely_logging') === 'true';
};
/**
 * Activate experiment
 * @param experimentKey {String} - experimentKey
 * @param uid           {String}   - uid
 * @returns {object}
 */


$sflyOptimizely.activate = function (experimentKey, uid, attributes) {
  var data = (0, _stringify.default)(attributes);
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/activate/").concat(experimentKey, "/").concat(uid), {
    method: 'POST',
    headers: postHeaders,
    body: data
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("activate(".concat(experimentKey, ",").concat(uid, ",").concat(data, ") => '").concat((0, _stringify.default)(result), "'"));
    }

    $sflyOptimizely.logActivateToAdobe(experimentKey, uid, data, result);
  });
  return promise;
};
/**
 * Get Datafile
 * @returns a promise that the caller can use to get the datafile, by saying:
 *  promise.then(datafiletext) { console.log(datafiletext) }
 */


$sflyOptimizely.getDatafile = function () {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/datafile"), {
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  }); // Attach a function to the promise to log the result.

  promise.then(function (datafile) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getDatafile() => '".concat((0, _stringify.default)(datafile), "'"));
    }
  });
  return promise;
};
/**
 * Set forced Variation
 * @param experimentKey {String}   - experimentKey
 * @param uid           {String}   - uid
 * @param variationKey  {String}   - variationKey
 * @returns {object}
 */


$sflyOptimizely.setForcedVariation = function (experimentKey, uid, variationKey) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/forcedVariation/").concat(experimentKey, "/").concat(uid, "/").concat(variationKey), {
    method: 'POST',
    headers: postHeaders
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("setForcedVariation(".concat(experimentKey, ",").concat(uid, ",").concat(variationKey, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
};
/**
 * Set Enabled Features
 * @param uid           {String}   - uid
 * @returns {object}
 */


$sflyOptimizely.getEnabledFeatures = function (uid, attributes) {
  var data = (0, _stringify.default)(attributes);
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/getEnabledFeatures/").concat(uid), {
    method: 'POST',
    headers: postHeaders,
    body: data
  }).then(function (s) {
    return handleResponse(s);
  }).catch(function (err) {
    return err;
  }); // register a callback to log the enabled features when they are available

  promise.then(function (enabledFeatures) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getEnabledFeatures(".concat(uid, ",").concat(data, ") => '").concat((0, _stringify.default)(enabledFeatures), "'"));
    }
  });
  return promise;
};
/**
 * Get the value of the feature variable for this user
 * @param feature       {String}   - feature
 * @param variableName  {String}   - variableName
 * @param uid           {String}   - uid
 * @returns a promise that the user can use to get the value of the feature variable.
 */


$sflyOptimizely.getFeatureVariable = function (featureName, variableName, uid) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/getFeatureVariableString/").concat(featureName, "/").concat(variableName, "/").concat(uid), {
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (featureVariableValue) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getFeatureVariable(".concat(featureName, ",").concat(variableName, ",").concat(uid, ") => '").concat((0, _stringify.default)(featureVariableValue), "'"));
    }
  });
  return promise;
};
/*
 * Determine if the named feature is enabled for the userid
 * @param feature       {String}   - feature
 * @param uid           {String}   - uid
 * @returns {object}
 */


$sflyOptimizely.isFeatureEnabled = function (featureName, uid, attributes) {
  if (attributes) {
    var data = (0, _stringify.default)(attributes);
    var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/isFeatureEnabled/").concat(featureName, "/").concat(uid), {
      method: 'POST',
      headers: postHeaders,
      body: data
    }).then(handleResponse).catch(function (err) {
      return err;
    });
    promise.then(function (result) {
      if ($sflyOptimizely.optimizelyLoggingEnabled()) {
        console.log("isFeatureEnabled(".concat(featureName, ",").concat(uid, ",").concat(data, ") => '").concat((0, _stringify.default)(result), "'"));
      }

      $sflyOptimizely.logIsFeatureEnabledToAdobe(featureName, uid, data, result);
    });
    return promise;
  } else {
    var _promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/isFeatureEnabled/").concat(featureName, "/").concat(uid), {
      headers: headers
    }).then(handleResponse).catch(function (err) {
      return err;
    });

    _promise.then(function (result) {
      if ($sflyOptimizely.optimizelyLoggingEnabled()) {
        console.log("isFeatureEnabled(".concat(featureName, ",").concat(uid, ") => '").concat((0, _stringify.default)(result), "'"));
      }

      $sflyOptimizely.logIsFeatureEnabledToAdobe(featureName, uid, '{}', result);
    });

    return _promise;
  }
};
/**
 * Get reloaded datafile
 * @returns {object}
 */


$sflyOptimizely.getReloadedDatafile = function () {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/reloadedDatafile"), {
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getReloadedDatafile() => '".concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};
/*
 * Track event
 * @param eventKey      {String}   - uid
 * @param uid           {String}   - uid
 */


$sflyOptimizely.trackEvent = function (eventKey, uid, attributes, eventTags) {
  var data = (0, _stringify.default)({
    attributes: attributes,
    eventTags: eventTags
  });
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/trackEvent/").concat(eventKey, "/").concat(uid), {
    method: 'POST',
    headers: postHeaders,
    body: data
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("trackEvent(".concat(eventKey, ",").concat(uid, ",").concat(data, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};
/*
 * Get user profile
 * @param uid           {String}   - uid
 */


$sflyOptimizely.getUserProfile = function (uid) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/userProfile/").concat(uid), {
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getUserProfile(".concat(uid, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};
/*
 * Delete user profile removes all the user's impression history so
 * that they will be rebucketed upon next impression.
 */


$sflyOptimizely.deleteUserProfile = function (uid) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/userProfile/").concat(uid), {
    method: 'DELETE',
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("deleteUserProfile(".concat(uid, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};
/*
 * Delete experiment removes all bucketing for all users in the given experiment,
 * so that all users will be rebucketed on next impression.  You would want to do
 * this after changing percentage to 100.
 */


$sflyOptimizely.deleteExperiment = function (experimentKey) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/experiment/").concat(experimentKey), {
    method: 'DELETE',
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("deleteExperiment(".concat(experimentKey, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};
/*
 * Get Variation
 * @param feature       {String}   - feature
 * @param uid           {String}   - uid
 * @returns {object}
 */


$sflyOptimizely.getVariation = function (experimentKey, uid) {
  var promise = fetch("".concat((0, _Utils.getWrapperURL)(), "/variation/").concat(experimentKey, "/").concat(uid), {
    headers: headers
  }).then(handleResponse).catch(function (err) {
    return err;
  });
  promise.then(function (result) {
    if ($sflyOptimizely.optimizelyLoggingEnabled()) {
      console.log("getVariation(".concat(experimentKey, ",").concat(uid, ") => '").concat((0, _stringify.default)(result), "'"));
    }
  });
  return promise;
};

//# sourceMappingURL=index.js.map